import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { api, setAuth } from '../../lib/api';
import { toast } from 'sonner';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      setAuth(res.data.token, res.data.user);
      toast.success(`Welcome back, ${res.data.user.name || res.data.user.email}`);
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a2744] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <p className="font-serif font-black text-white text-2xl">Vote Steve Lesperance</p>
          <p className="text-xs font-bold tracking-[0.25em] text-[#C9A84C] uppercase mt-1">Ward 8 · Campaign Admin</p>
        </div>
        <Card>
          <CardContent className="p-6 sm:p-8">
            <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
              <div>
                <label className="block font-bold text-[#1a2744] mb-2 text-sm">Email</label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" data-testid="admin-login-email" autoComplete="username" />
              </div>
              <div>
                <label className="block font-bold text-[#1a2744] mb-2 text-sm">Password</label>
                <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" data-testid="admin-login-password" autoComplete="current-password" />
              </div>
              <Button type="submit" disabled={busy} className="w-full h-12 bg-[#1a2744] hover:bg-[#243456] text-white font-bold btn-press" data-testid="admin-login-submit">
                {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Lock className="h-4 w-4 mr-2" />} Sign In
              </Button>
            </form>
          </CardContent>
        </Card>
        <p className="text-center text-xs text-slate-400 mt-4"><a href="/" className="underline">← Back to the public site</a></p>
      </div>
    </div>
  );
}
